<template>
  <v-container fluid class="user-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="1" class="d-flex justify-end mt-3">
              <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null" @click="goBack()"
              >mdi-arrow-left</v-icon>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="users-table"
              :headers="headers"
              :items="items"
              sort-by="createdAt"
              :items-per-page="itemPerPage">
              <template v-slot:item.actions="{ item }">
                <!-- <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn> -->
                <v-btn icon color="primary" @click="goSensors(item)">
                  <v-icon>mdi-leak</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UserList',
  data() {
    return {
      items: [],
      headers: [
        { text: '아이디', value: 'id' },
        { text: '장소명', value: 'name' },
        { text: '표시순서', value: 'displaySunBun' },
        { text: '필요한 동작센서 수', value: 'requireMotionSensorCount' },
        { text: '연결된 동작센서 수', value: 'detectedMotionSensorCount' },
        { text: '필요한 문열림센서 수', value: 'requireDoorSensorCount' },
        { text: '연결된 문열림센서 수', value: 'detectedDoorSensorCount' },
        { text: '생성일', value: 'createdAt' },
        { text: '수정일', value: 'updatedAt' },
        { text: '삭제일', value: 'deletedAt' },
        { text: '동작', value: 'actions', sortable: false },
      ],
      selected: [],
    }
  },

  computed: {

  },
  created () {
    this.user = this.$route.params.user
    this.getItems()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getItems() {
        this.items = [];
        axios
          .post(`/users/admin_get_location`, {
            userID: this.user.id,
          })
          .then((res) => {
            if (res.status === 200) {
              this.items = res.data;
              console.log(this.items)
              if (this.items.length > 0) {
                //this.selectRow(0);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
    goSensors(item) {
      this.$router.push({ name: 'UserSensors', params: { locationID: item.id }})
    },
  }
}
</script>

<!-- <style src="./List.scss" lang="scss"></style> -->
